<template>
    <div class="pt-16">
        <div class="relative mb-2">
            <div class="absolute w-full flex justify-center bottom-0">
                <div class="w-32 h-28 campaign-image rounded-md overflow-hidden">
                    <div class="rounded-md" :style="{'background-image': `url('${serialModel.campaignImgUrl}')`}"></div>
                </div>
            </div>
        </div>
        <div>
            <div class="text-center text-tc-gray-3 text-22 px-4">
                {{serialModel.campaignName}}
            </div>
            <div class="flex items-center justify-center text-20">
                <div class="text-tc-gray-3">{{lbl.detail.use_point}}</div>
                <div class="text-tc-blue-1 mx-1"> 
                    <span class="campaign-baht" v-if="isShowBaht">
                        ฿{{ FilterNumberFormat(serialModel.campaign.maximumPartialPrice) }} + {{FilterNumberFormat(serialModel.campaign.maximumPartialPoints ?? 0)}}
                    </span>
                    <span class="campaign-baht" v-if="!isShowBaht"> 
                        {{FilterNumberFormat(serialModel.campaign.pointPerUnit ?? 0)}}
                    </span> 
                </div>
                <div>
                    <img class="w-3" src="../../../../../assets/icon/icon-tipcoin.png">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from '@/mixin/LocaleMixin';
import { CampaignType } from '@/helper/StaticValue'
//import Util from '@/helper/Utility.js';
export default {
    name: "SerialDetail",
    inject: ["CampaignStore"],
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
    },
    data: function() {
        return {
            point: 0,
        };//
    },
    computed:{
        isShowBaht: function () {
            return (this.serialModel.campaign.type ==   CampaignType.Privilege20);
        },
    },
    created: function() {
        //Util.log('serialModel', this.serialModel);
        //Util.log('CampaignStore', this.CampaignStore.state.campaign);
        this.point = this.CampaignStore && this.CampaignStore.state && this.CampaignStore.state.campaign && this.CampaignStore.state.campaign.pointPerUnit
        ? this.CampaignStore.state.campaign.pointPerUnit
        : 0;
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        div {
            @include boxRatio(66.66%);
        }
    }
</style>
